import { Directive, HostListener, HostBinding, Output, EventEmitter, Input, ElementRef, Renderer2, OnInit } from '@angular/core';

@Directive({
    selector: '[fileDragDrop]',
    standalone: false
})

export class FileDragNDropDirective implements OnInit {
  @Input() styleClass;
  @Input() dragDropActive = true;
  @Output() private filesChangeEmitter: EventEmitter<File[]> = new EventEmitter();
  @HostBinding('style.background') private background;
  @HostBinding('style.border') private borderStyle;
  @HostBinding('style.border-width') private borderWidth;
  @HostBinding('style.border-color') private borderColor;
  @HostBinding('style.border-radius') private borderRadius;
  defaultBorderColor = 'none';
  defaultBorderWidth = 'none';
  defaultBorderStyle = 'none';
  private dragCounter = 0;
  private overlayElement: HTMLElement | null = null;

  constructor(private element: ElementRef, private renderer: Renderer2) {

  }

  ngOnInit() {
    if (this.styleClass) {
      const styles = window.getComputedStyle(document.querySelector(`.${this.styleClass}`));
      this.defaultBorderColor = styles.borderTopColor + ' ' + styles.borderRightColor + ' ' + styles.borderBottomColor + ' ' + styles.borderLeftColor;
      this.defaultBorderWidth = styles.borderTopWidth + ' ' + styles.borderRightWidth + ' ' + styles.borderBottomWidth + ' ' + styles.borderLeftWidth;
      this.defaultBorderStyle = 'solid';
    }
  }

  @HostListener('dragover', ['$event']) public onDragOver(evt) {
    if (!this.dragDropActive) {
      return;
    }
    evt.preventDefault();
    evt.stopPropagation();
    this.background = 'lightgray';
    this.borderColor = '#9E9E9E';
    this.borderStyle = 'dashed';
    this.borderWidth = '2px';
    if (!this.overlayElement) {
      this.createOverlay();
    }
  }

  @HostListener('dragenter', ['$event'])
  onDragEnter(event: DragEvent) {
    if (!this.dragDropActive) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    this.dragCounter++;
    this.background = 'lightgray';
    this.borderColor = '#9E9E9E';
    this.borderStyle = 'dashed';
    this.borderWidth = '2px';
    if (!this.overlayElement) {
      this.createOverlay();
    }
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    if (!this.dragDropActive) {
      return;
    }
    evt.preventDefault();
    evt.stopPropagation();
    this.dragCounter--;
    if (this.dragCounter === 0) {
      this.resetStyle();
      this.removeOverlay();
    }
  }

  @HostListener('drop', ['$event']) public onDrop(evt) {
    if (!this.dragDropActive) {
      return;
    }
    evt.preventDefault();
    evt.stopPropagation();
    this.dragCounter = 0;

    this.resetStyle();
    this.removeOverlay();

    const files = evt.dataTransfer.files;
    const validFiles: any = {target: {files: files}};
    this.filesChangeEmitter.emit(validFiles);
  }

  @HostListener('dragend', ['$event'])
  onDragEnd(event: DragEvent) {
    if (!this.dragDropActive) {
      return;
    }
    this.dragCounter = 0;
    this.resetStyle();
    this.removeOverlay();
  }

  private removeOverlay() {
    if (this.overlayElement) {
      this.renderer.removeChild(this.element.nativeElement, this.overlayElement);
      this.overlayElement = null;
    }
  }

  private resetStyle() {
    this.background = 'none';
    this.borderColor = this.defaultBorderColor;
    this.borderWidth = this.defaultBorderWidth;
    this.borderStyle = this.defaultBorderStyle;
  }

  private createOverlay() {
    this.overlayElement = this.renderer.createElement('div');

    this.renderer.setStyle(this.overlayElement, 'position', 'absolute');
    this.renderer.setStyle(this.overlayElement, 'top', '0');
    this.renderer.setStyle(this.overlayElement, 'left', '0');
    this.renderer.setStyle(this.overlayElement, 'width', '100%');
    this.renderer.setStyle(this.overlayElement, 'height', '100%');
    this.renderer.setStyle(this.overlayElement, 'background', 'rgba(244, 156, 25, 0.2)');
    this.renderer.setStyle(this.overlayElement, 'display', 'flex');
    this.renderer.setStyle(this.overlayElement, 'justify-content', 'center');
    this.renderer.setStyle(this.overlayElement, 'align-items', 'center');
    this.renderer.setStyle(this.overlayElement, 'color', '#fff');
    this.renderer.setStyle(this.overlayElement, 'z-index', '10000');
    this.renderer.setStyle(this.overlayElement, 'pointer-events', 'none');

    const textElement = this.renderer.createElement('div');
    this.renderer.appendChild(this.overlayElement, textElement);

    this.renderer.appendChild(this.element.nativeElement, this.overlayElement);
  }
}
